/* eslint-disable default-param-last */
import { SHOW_INVOICE_LIST_BY_ORDER_ID } from 'actionTypes/invoiceListByOrderIdActionTypes';

const initialState = {
  status: false,
  selectedOrderId: null,
};

const invoiceListByOrderIdReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_INVOICE_LIST_BY_ORDER_ID:
      return {
        ...state,
        status: action.payload.status,
        selectedOrderId: action.payload.selectedOrderId,
      };
    default:
      return state;
  }
};

export default invoiceListByOrderIdReducer;
